(function () {
    'use strict';

    angular.module("imApp").factory("createPoPuService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 228,
                    parameters: parms || {}
                });
            },
            createObj: function (edit) {
                return $ihttp.post({
                    method: 229,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
